import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetDishesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryId } from 'backend/dishes';
import MultipleSelect from './components/MultipleSelect';
import style from './AdditionalDishMultipleSelect.module.scss';

interface IAdditionalDishMultipleSelect {
	setFetchedAdditionalDishes: (value: IItemForGetShortInfo[]) => void;
	selectedAdditionalDishSubCategory: Nullable<string>;
	setAdditionalDishes: (value: string[]) => void;
	selectedAdditionalDishes: string[];
}

const AdditionalDishMultipleSelect: React.FC<IAdditionalDishMultipleSelect> = ({
	selectedAdditionalDishes,
	selectedAdditionalDishSubCategory,
	setFetchedAdditionalDishes,
	setAdditionalDishes,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, string>(
		selectedAdditionalDishSubCategory ? getDishesShortBySubCategoryId : null,
		selectedAdditionalDishSubCategory || '',
	);

	useEffect(() => {
		refetch();
	}, [selectedAdditionalDishSubCategory]);

	useEffect(() => {
		if (response) {
			setFetchedAdditionalDishes(response.data.dishes);
		}
	}, [response]);

	return (
		<div className={style.container}>
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.dishes || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					selectedAdditionalDishes={selectedAdditionalDishes}
					selectedAdditionalDishSubCategory={selectedAdditionalDishSubCategory}
					setAdditionalDishes={setAdditionalDishes}
				/>
			</div>
		</div>
	);
};

export default React.memo(AdditionalDishMultipleSelect);
